'use client';

import api from '../index';
import { MapProducts } from './mapProducts';
import { Plan } from './types';
import useSWR from 'swr';

export const ProductsFetch = () => {
  const { data, mutate, isLoading } = useSWR<Plan[]>(
    `products`,
    async (): Promise<Plan[]> => {
      const { data } = await api.get<Plan[]>(`/core/planos`);

      return MapProducts(data);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data, mutate, isLoading };
};
